import { useMemo } from "react";

import { GridRowsProp } from "@mui/x-data-grid";
import moment from "moment";

import { VideoStatusEnum } from "../../../../../common/models/enums";
import { EVENTS_DATE_FORMAT } from "../../../../data-hub/components/models/common/events.constants";
import { getRowIndex } from "../../../../data-hub/components/models/common/events.helpers";
import {
  IParsedSecurityEvent,
  ISecurityEventsTableRow,
} from "../../../../data-hub/components/models/common/events.models";
import { useGetSecurityEventsServer } from "./useGetSecurityEventsServer";

export const useGetSecurityEventsTableRows = () => {
  const {
    parsedResult,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
  } = useGetSecurityEventsServer();

  const rows = useMemo((): GridRowsProp<ISecurityEventsTableRow> => {
    if (!parsedResult) {
      return [];
    }

    const filteredItems = parsedResult.filter(
      (item: IParsedSecurityEvent): item is IParsedSecurityEvent =>
        !!item?.mediaOutput
    );

    const mappedData: ISecurityEventsTableRow[] = filteredItems.map(
      (item: IParsedSecurityEvent, index: number) => {
        return {
          isDeleted: item?.is_del ?? false,
          processTime: item?.process_time || Date.now(),
          rowIndex: getRowIndex(paginationModel, index),
          rowId: item?.time || Date.now(),
          nodeId: item?.node_id
            ?.replace("C_", "C#")
            .replace("_L_", "#L#")
            .replace("_N_", "#N#"),
          location: item?.loc_id,
          timestamp: moment.utc(item?.time).local().format(EVENTS_DATE_FORMAT),
          timestreamTimestamp: item?.time,
          keyFrame: item?.keyframe,
          mediaOutput: item?.mediaOutput,
          signedUrlKeyFrame: item?.signedUrlKeyFrame,
          signedUrlMediaOutput: item?.signedUrlMediaOutput,
          cameraId: item?.camera_id,
          peopleCount: item?.people_c,
          vehicleCount: item?.vehicle_c,
          peopleDelta: item?.people_delta,
          vehicleDelta: item?.vehicle_delta,
          customerId: item?.cust_id,
          inWindow: item?.in_window,
          videoStatus: item?.vid_status,
          isRetrieving: item?.vid_status === VideoStatusEnum.RETRIEVING,
          originalTimeInUTC: item?.time,
        };
      }
    );

    // remove duplicates by rowId
    const uniqueMappedData = Array.from(
      new Map(mappedData.map(item => [item["rowId"], item])).values()
    );

    return uniqueMappedData;
  }, [parsedResult, paginationModel]);

  return {
    rows,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
  };
};
